export default "__VITE_ASSET__B99jvz5X__"